<template>
    <div class="content">
        <div class="finish" @click="showFeelBox">{{ $t('startTrain.finish') }}</div>
        <div class="title-box">
            <div class="title">{{ planInfo.planName }}</div>
            <div class="act-time">{{ SwitchTime24(sportInfo.actTime) }}</div>
            <div class="num-box">
                <div>{{ sportInfo.actionCount }}/{{ planInfo.actionCount }} {{ $t('startTrain.action') }}</div>
                <div>{{ sportInfo.groupCount }}/{{ planInfo.groupCount }} {{ $t('startTrain.group') }}</div>
                <div v-if="planInfo.totalCapacity">{{ sportInfo.totalCapacity }}/{{ planInfo.totalCapacity }}
                    {{ $t('startTrain.capacity') }}
                </div>
            </div>
        </div>
        <div class="group-item" v-for="(item, i) in actionList">
            <van-row class="group-top">
                <van-col span="5">
                    <img class="active-icon" :src="item.bannerUrl" @click="toActionDesc(item.actionId)">
                </van-col>
                <van-col span="19">
                    <div class="flex-line" @click="toActionDesc(item.actionId)">
                        <div class="action-name" v-if="$i18n.locale === 'en'">{{ item.actionNameEn }}</div>
                        <div class="action-name" v-else-if="$i18n.locale === 'ja'">{{ item.actionNameJa }}</div>
                        <div class="action-name" v-else>{{ item.actionName }}</div>
                        <div class="action-capacity" v-if="item.recordType == 1">{{
                                item.currentCapacity
                            }}/{{ item.capacity }} {{ item.unit }}
                        </div>
                        <div class="action-capacity" v-if="item.recordType == 3">{{
                                item.currentf
                            }}/{{ item.f }} {{ $t('unit.time') }}
                        </div>
                        <div class="action-capacity" v-if="item.recordType == 4">{{
                                item.currentd
                            }}/{{ item.d }} km
                        </div>
                    </div>
                    <div class="add-title-box" :class="{'add-title-box-ja':$i18n.locale === 'ja'}"
                         v-if="item.recordType == 1">
                        <div class="group-title">{{ $t('planEdit.group') }}</div>
                        <div class="weight-title">{{ $t('planEdit.weight') }}</div>
                        <div class="frequency-title">{{ $t('planEdit.frequency') }}</div>
                        <!--                        <div class="distance-unit-box">-->
                        <!--                            {{ item.unit }}-->
                        <!--                        </div>-->
                    </div>
                    <div class="add-title-box" :class="{'add-title-box-ja':$i18n.locale === 'ja'}"
                         v-if="item.recordType == 2">
                        <div class="group-title">{{ $t('planEdit.group') }}</div>
                        <div class="duration-title">{{ $t('planEdit.duration') }}</div>
                    </div>
                    <div class="add-title-box" :class="{'add-title-box-ja':$i18n.locale === 'ja'}"
                         v-if="item.recordType == 3">
                        <div class="group-title">{{ $t('planEdit.group') }}</div>
                        <div class="weight-title">{{ $t('planEdit.frequency') }}</div>
                    </div>
                    <div class="add-title-box" :class="{'add-title-box-ja':$i18n.locale === 'ja'}"
                         v-if="item.recordType == 4">
                        <div class="group-title">{{ $t('planEdit.group') }}</div>
                        <div class="weight-title">{{ $t('planEdit.distance') }}</div>
                        <!--                        <div class="distance-unit-box">km</div>-->
                    </div>
                    <div class="add-line" v-for="(group, j) in item.actionList" :key="j">
                        <div class="add-index" :class="{'add-index-readonly':item.currentIndex < j}">{{
                                j + 1
                            }}
                        </div>
                        <div v-if="item.currentIndex == j">
                            <div class="add-weight-input" v-if="item.recordType == 1">
                                <van-field class="group-input" type="digit" input-align="center"
                                           v-model="group.w"/>
                            </div>
                            <div class="add-frequency-input" v-if="item.recordType == 1">
                                <van-field class="group-input" type="digit" input-align="center"
                                           v-model="group.f"/>
                            </div>
                            <div class="add-weight-input" v-if="item.recordType == 2">
                                <div class="group-input duration-input">{{ SwitchTime24(group.tt) }}</div>
                            </div>
                            <div class="add-weight-input" v-if="item.recordType == 3">
                                <van-field class="group-input" type="digit" input-align="center"
                                           v-model="group.f"/>
                            </div>
                            <div class="add-weight-input" v-if="item.recordType == 4">
                                <van-field class="group-input" type="digit" input-align="center"
                                           v-model="group.d"/>
                            </div>
                            <div class="finish-input" v-if="item.recordType != 2 && item.recordType != 4">
                                <img class="finish-icon" @click="finishClick(i, j, item, group)"
                                     src="@/assets/theme/light/trainPlan/09startTrain/02finish.svg">
                            </div>
                            <div class="finish-input" v-else>
                                <div class="start-timing" @click="startTiming(i, j, item.recordType, group.tt)">
                                    {{ $t('startTrain.startTiming') }}
                                </div>
                            </div>
                        </div>
                        <div v-else-if="item.currentIndex > j">
                            <div class="add-weight-input" v-if="item.recordType == 1">
                                <div class="group-input group-input-before">{{ group.w }}</div>
                            </div>
                            <div class="add-frequency-input" v-if="item.recordType == 1">
                                <div class="group-input group-input-before">{{ group.f }}</div>
                            </div>
                            <div class="add-weight-input" v-if="item.recordType == 2">
                                <div class="group-input duration-input group-input-before">
                                    {{ SwitchTime24(group.t) }}
                                </div>
                            </div>
                            <div class="add-weight-input" v-if="item.recordType == 3">
                                <div class="group-input group-input-before">{{ group.f }}</div>
                            </div>
                            <div class="add-weight-input" v-if="item.recordType == 4">
                                <div class="group-input group-input-before">{{ group.d }}</div>
                            </div>
                            <div class="finish-input">
                                <img class="finish-icon"
                                     src="@/assets/theme/light/trainPlan/09startTrain/01finish.svg">
                            </div>
                        </div>
                        <div v-else>
                            <div class="add-weight-input" v-if="item.recordType == 1">
                                <div class="group-input group-input-after">{{ group.w }}</div>
                            </div>
                            <div class="add-frequency-input" v-if="item.recordType == 1">
                                <div class="group-input group-input-after">{{ group.f }}</div>
                            </div>
                            <div class="add-weight-input" v-if="item.recordType == 2">
                                <div class="group-input duration-input group-input-after">
                                    {{ SwitchTime24(group.tt) }}
                                </div>
                            </div>
                            <div class="add-weight-input" v-if="item.recordType == 3">
                                <div class="group-input group-input-after">{{ group.f }}</div>
                            </div>
                            <div class="add-weight-input" v-if="item.recordType == 4">
                                <div class="group-input group-input-after">{{ group.d }}</div>
                            </div>
                            <div class="finish-input" v-if="item.recordType != 2 && item.recordType != 4">
                                <img class="finish-icon"
                                     src="@/assets/theme/light/trainPlan/09startTrain/03finish.svg">
                            </div>
                            <div class="finish-input" v-else>
                                <div class="start-timing start-timing-after">{{ $t('startTrain.startTiming') }}</div>
                            </div>
                        </div>
                    </div>
                </van-col>
            </van-row>
        </div>
        <van-dialog
            v-model="restShow"
            :title="$t('startTrain.rest')"
            confirmButtonColor="var(--chart-color-1)"
            :confirmButtonText="$t('startTrain.finish')"
            @confirm="confirmRest"
        >
            <div class="dialog-time">{{ SwitchTime24(restTime) }}</div>
        </van-dialog>
        <van-dialog
            v-model="durationShow"
            :title="$t('startTrain.duration')"
            confirmButtonColor="var(--chart-color-1)"
            :confirmButtonText="$t('startTrain.finish')"
            @confirm="confirmDuration"
        >
            <div class="dialog-time">{{ SwitchTime24(actionTime) }}</div>
        </van-dialog>
        <van-dialog
            v-model="targetDurationShow"
            confirmButtonColor="var(--chart-color-1)"
            :confirmButtonText="$t('startTrain.finish')"
            @confirm="confirmDuration"
        >
            <div class="circle-box">
                <van-circle class="circle-pro" :size="270*ratio" :stroke-width="70*ratio"
                            :value="actionTime/targetDuration*100" color="#00BD9B" layer-color="var(--bg-color-1)" :rate="100"/>
                <div class="circle-title">{{ $t('startTrain.duration') }}</div>
                <div class="dialog-time circle-time">{{ SwitchTime24(actionTime) }}</div>
                <div class="target-time">{{ SwitchTime24(targetDuration) }}</div>
            </div>
        </van-dialog>
        <van-dialog
            v-model="feelShow"
            :title="$t('startTrain.feel')"
            confirmButtonColor="var(--chart-color-1)"
            :confirmButtonText="$t('startTrain.confirm')"
            @confirm="confirmFeel"
        >
            <div class="feel-type-box">
                <van-row>
                    <van-col span="8">
                        <div class="feel-item" :class="{'feel-not-active': feelType!=0}" @click="feelType=0">
                            <img class="feel-icon" src="@/assets/theme/light/trainPlan/09startTrain/04easy.png">
                            <div class="feel-text">{{ $t('startTrain.easy') }}</div>
                        </div>

                    </van-col>
                    <van-col span="8">
                        <div class="feel-item" :class="{'feel-not-active': feelType!=1}" @click="feelType=1">
                            <img class="feel-icon" src="@/assets/theme/light/trainPlan/09startTrain/05normal.png">
                            <div class="feel-text">{{ $t('startTrain.normal') }}</div>
                        </div>

                    </van-col>
                    <van-col span="8">
                        <div class="feel-item" :class="{'feel-not-active': feelType!=2}" @click="feelType=2">
                            <img class="feel-icon" src="@/assets/theme/light/trainPlan/09startTrain/06hard.png">
                            <div class="feel-text">{{ $t('startTrain.hard') }}</div>
                        </div>
                    </van-col>
                </van-row>
                <div class="feel-input-box">
                    <van-field class="feel-input" type="textarea"
                               v-model="trainFeel"
                               :placeholder="$t('startTrain.feelInput')"
                               maxlength="200"
                               rows="4"
                    />
                </div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import {
    SwitchTime24,
    getNowTimeToSecond
} from "../../utils/dateUtils";
import {addSportTrain} from "../../api/trainPlan";
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'startTrain',
    data() {
        return {
            userPlanId: 0,
            planInfo: {
                actionCount: '',
                groupCount: '',
                totalCapacity: '',
            },
            sportInfo: {
                planName: '',
                actionCount: 0,
                groupCount: 0,
                totalCapacity: 0,
                actTime: 0
            },
            actionList: [],
            actTimeTimer: null,
            actionTimer: null,
            actionTime: 0,
            currentIndex: 0,
            restShow: false,
            restTime: 0,
            restTimer: null,
            durationShow: false,
            currentI: 0,
            currentJ: 0,
            feelShow: false,
            feelType: 0,
            trainFeel: '',
            startSportTime: '',
            endSportTime: '',
            totalSportTime: 0, // 除休息时间运动时长
            from: '',
            targetDurationShow: false,
            targetDuration: 0,
            ratio: 1,
            audio: new Audio(require('@/assets/theme/light/trainPlan/09startTrain/07finish.mp3')),
            isPlayFinish: false,
            theme: 'light'
        }
    },
    mounted() {
        this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
        this.startSportTime = getNowTimeToSecond();
        if (this.$route.query.userPlanId) {
            this.userPlanId = this.$route.query.userPlanId;
            this.getUserTrainPlanById();
        }
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme;
        }
        // 启动计时器，每秒增加 actTime
        this.actTimeTimer = setInterval(() => {
            this.sportInfo.actTime++;
        }, 1000);
        this.actionTimer = setInterval(() => {
            this.actionTime++;
            if (this.targetDurationShow && !this.isPlayFinish) {
                if (this.actionTime >= this.targetDuration) {
                    console.log('播放音频');
                    // 播放音频
                    this.audio.currentTime = 0; // 重置音频到开始位置
                    this.audio.play().catch(error => {
                        console.error('音频播放失败:', error);
                    });
                    this.isPlayFinish = true;
                }
            }
        }, 1000);
        if (this.$route.query.from) {
            this.from = this.$route.query.from;
        }
    },
    beforeDestroy() {
        // 清除计时器
        if (this.actTimeTimer) {
            clearInterval(this.actTimeTimer);
        }
        if (this.actionTimer) {
            clearInterval(this.actionTimer);
        }
        if (this.restTimer) {
            clearInterval(this.restTimer);
        }
    },
    methods: {
        getUserTrainPlanById() {
            this.$api.trainPlan.getUserTrainPlanById({
                userPlanId: this.userPlanId
            }).then(res => {
                this.actionList = res.info.actionList;
                this.planInfo = res.info;
                this.initActionList();
            })
        },
        SwitchTime24(num) {
            if (!num) {
                return '00:00:00'
            }
            return SwitchTime24(num)
        },
        initActionList() {
            let actionListGroup = JSON.parse(this.planInfo.actionListGroup)
            let actionListUnit = [];
            if (this.planInfo.actionListUnit) {
                actionListUnit = this.planInfo.actionListUnit.split(',')
            }
            let index = 0;
            // 将 actionId 字符串解析为数组
            const actionIdArray = this.planInfo.actionListId.split(',').map(Number);

            // 根据 actionIdArray 的顺序对 actionList 进行排序
            this.actionList.sort((a, b) => {
                return actionIdArray.indexOf(a.actionId) - actionIdArray.indexOf(b.actionId);
            });
            for (let i = 0; i < this.actionList.length; i++) {
                this.actionList[i].currentIndex = 0
                this.actionList[i].currentCapacity = 0
                this.actionList[i].currentf = 0
                this.actionList[i].currentd = 0
                this.actionList[i].f = 0
                this.actionList[i].d = 0
                this.actionList[i].capacity = 0
                this.actionList[i].actionList = actionListGroup[i]
                if (actionListUnit.length > 0) {
                    this.actionList[i].unit = actionListUnit[i]
                }
                for (let j = 0; j < this.actionList[i].actionList.length; j++) {
                    this.actionList[i].actionList[j].tt = this.actionList[i].actionList[j].t;
                    this.actionList[i].actionList[j].t = 0;
                    this.actionList[i].actionList[j].rt = 0;
                    if (this.actionList[i].recordType === 3) {
                        this.actionList[i].f = this.actionList[i].f + parseInt(this.actionList[i].actionList[j].f);
                    }
                    if (this.actionList[i].recordType === 4) {
                        this.actionList[i].d = this.actionList[i].d + parseInt(this.actionList[i].actionList[j].d);
                    }
                    if (this.actionList[i].recordType === 1) {
                        this.actionList[i].capacity = this.actionList[i].capacity + parseInt(this.actionList[i].actionList[j].w) * parseInt(this.actionList[i].actionList[j].f);
                    }
                }

            }
        },
        finishClick(i, j, item, group) {
            this.currentI = i;
            this.currentJ = j;
            item.currentIndex++;
            if (j == item.actionList.length - 1) {
                this.sportInfo.actionCount++;
            }
            if (item) {
                if (item.recordType === 1) {
                    this.sportInfo.totalCapacity = this.sportInfo.totalCapacity + (parseInt(group.w) * parseInt(group.f));
                    this.actionList[i].currentCapacity = this.actionList[i].currentCapacity + parseInt(group.w) * parseInt(group.f);
                }
                if (item.recordType === 3) {
                    this.actionList[i].currentf = this.actionList[i].currentf + parseInt(group.f);
                }

            }
            this.currentIndex++;
            this.sportInfo.groupCount = this.currentIndex;
            this.actionList[i].actionList[j].t = this.actionTime;
            this.totalSportTime = this.totalSportTime + this.actionTime;
            this.actionTime = 0;
            this.restShow = true;
            this.restTimer = setInterval(() => {
                this.restTime++;
            }, 1000);
        },
        confirmRest() {
            this.actionList[this.currentI].actionList[this.currentJ].rt = this.restTime;
            this.restTime = 0;
            this.actionTime = 0;
            clearInterval(this.restTimer);
            this.checkFinish();
        },
        startTiming(i, j, recordType, target) {
            this.actionTime = 0;
            this.currentI = i;
            this.currentJ = j;
            if (recordType === 2) {
                this.targetDuration = target;
                this.targetDurationShow = true;
                this.isPlayFinish = false
            } else {
                this.durationShow = true;
            }
        },
        confirmDuration() {
            this.finishClick(this.currentI, this.currentJ, this.actionList[this.currentI], this.actionList[this.currentI].actionList[this.currentJ])
        },
        checkFinish() {
            if (this.currentIndex >= this.planInfo.groupCount) {
                this.showFeelBox();
            }
        },
        showFeelBox() {
            this.endSportTime = getNowTimeToSecond();
            this.feelShow = true;
            if (this.actTimeTimer) {
                clearInterval(this.actTimeTimer);
            }
        },
        confirmFeel() {
            let actionListGroup = [];
            for (let i = 0; i < this.actionList.length; i++) {
                actionListGroup.push(this.actionList[i].actionList);
            }
            for (let i = 0; i < actionListGroup.length; i++) {
                for (let j = 0; j < actionListGroup[i].length; j++) {
                    if (actionListGroup[i][j].w) {
                        actionListGroup[i][j].w = parseInt(actionListGroup[i][j].w);
                    }
                    if (actionListGroup[i][j].f) {
                        actionListGroup[i][j].f = parseInt(actionListGroup[i][j].f);
                    }
                    if (actionListGroup[i][j].d) {
                        actionListGroup[i][j].d = parseInt(actionListGroup[i][j].d);
                    }
                }
            }
            this.$api.trainPlan.addSportTrain({
                userPlanId: this.userPlanId,
                planName: this.planInfo.planName,
                startSportTime: this.startSportTime,
                endSportTime: this.endSportTime,
                actTime: this.sportInfo.actTime,
                restTime: this.sportInfo.actTime - this.totalSportTime,
                totalCapacity: this.sportInfo.totalCapacity,
                trainFeelType: this.feelType,
                trainFeel: this.trainFeel,
                actionListId: this.planInfo.actionListId,
                actionListGroup: JSON.stringify(actionListGroup),
                actionListUnit: this.planInfo.actionListUnit,
                trainParts: this.planInfo.trainParts,
                trainMuscles: this.planInfo.trainMuscles,
                groupCount: this.planInfo.groupCount,
                finishedGroupCount: this.sportInfo.groupCount,
                finishedActionCount: this.sportInfo.actionCount,
            }).then(res => {
                WebJSBridge.call("startTrainSuccess", null, function (res) {
                });
                this.$router.push({
                    name: 'sportTrainDesc',
                    query: {
                        sportId: res.info,
                        from: this.from,
                        lang: this.$i18n.locale,
                        theme: this.theme
                    }
                })
            })
        },
        toActionDesc(id) {
            this.$router.push({
                name: 'actionDesc',
                query: {
                    actionId: id,
                    theme: this.theme
                }
            })
        }
    }
}
</script>

<style scoped>

.content {
    padding-top: 44px;
}

.finish {
    width: 74px;
    height: 35px;
    background: #DAEDE5;
    border-radius: 8px 8px 8px 8px;
    color: #00BD9B;
    line-height: 35px;
    text-align: center;
    font-size: 15px;
    margin: 4px 0 0px 26px;
}

.title-box {
    width: 100%;
    height: 96px;
    position: relative;
}

.title {
    font-size: 17px;
    color: var(--text-color-1);
    position: absolute;
    left: 26px;
    top: 16px;
}

.act-time {
    font-weight: bold;
    font-size: 32px;
    color: #00BD9B;
    font-family: PP;
    position: absolute;
    left: 25px;
    top: 41px;
}

.num-box {
    width: 200px;
    font-size: 13px;
    color: var(--text-color-2);
    line-height: 20px;
    text-align: right;
    position: absolute;
    right: 22px;
    top: 16px;
}


.group-item {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 0 auto 12px;
    padding-bottom: 10px;
}

.active-icon {
    width: 46px;
    margin-left: 18px;
}

.group-top {
    padding-top: 15px;
}

.flex-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.action-name {
    font-size: 17px;
    color: var(--text-color-1);
}

.action-capacity {
    font-size: 12px;
    color: var(--text-color-2);
    margin-right: 22px;
}


.action-num {
    font-size: 12px;
    color: var(--text-color-3);
}

.action-omit {
    color: var(--text-color-2);
    font-size: 24px;
    margin-right: 22px;
}

.add-top-line {
}

.add-title-box {
    width: 100%;
    height: 30px;
    position: relative;
    color: var(--text-color-3);
    font-size: 12px;
}

.add-title-box-ja {
    height: 45px;
}

.group-title {
    position: absolute;
    left: 0;
    top: 6px;
    width: 40px;
}

.weight-title {
    position: absolute;
    width: 46px;
    text-align: center;
    left: 37px;
    top: 6px;
}

.duration-title {
    position: absolute;
    width: 105px;
    text-align: center;
    left: 37px;
    top: 6px;
}

.frequency-title {
    position: absolute;
    width: 46px;
    text-align: center;
    left: 96px;
    top: 6px;
}

.unit-box {
    width: 52px;
    height: 21px;
    background: var(--bg-color-1);
    border-radius: 7px 7px 7px 7px;
    position: absolute;
    right: 22px;
    top: 4px;
}

.kg-unit {
    width: 26px;
    height: 21px;
    border-radius: 7px 7px 7px 7px;
    position: absolute;
    left: 0;
    text-align: center;
    line-height: 21px;
}

.lbs-unit {
    width: 26px;
    height: 21px;
    border-radius: 7px 7px 7px 7px;
    position: absolute;
    right: 0;
    text-align: center;
    line-height: 21px;
}

.active {
    background: #00BD9B;
    color: var(--bg-color-2);
}

.add-weight-input {
    position: absolute;
    left: 37px;
}

.group-input {
    background-color: var(--bg-color-1);
    width: 46px;
    height: 32px;
    border-radius: 8px;
    padding: 4px;
}

.duration-input {
    width: 105px;
    padding: 0;
    text-align: center;
    font-size: 14px;
    line-height: 32px;
}

.duration-input-after {
    background: var(--bg-color-1);
}

.group-input-after {
    padding: 0;
    text-align: center;
    color: var(--text-color-3);
    font-size: 14px;
    line-height: 32px;
}

.group-input-before {
    background: var(--bg-color-2);
    padding: 0;
    text-align: center;
    font-size: 14px;
    line-height: 32px;
}

.add-line {
    width: 100%;
    position: relative;
    height: 32px;
    padding-bottom: 10px;
    color: var(--text-color-1);
}

.add-index {
    font-size: 13px;
    color: var(--text-color-1);
    text-align: center;
    height: 32px;
    line-height: 32px;
    position: absolute;
    left: 0;
}

.add-frequency-input {
    position: absolute;
    left: 96px;
}

.total-capacity {
    font-size: 12px;
    color: var(--text-color-2);
    float: right;
    margin-right: 22px;
}

.distance-unit-box {
    height: 21px;
    border-radius: 7px 7px 7px 7px;
    font-size: 12px;
    color: var(--text-color-2);
    text-align: center;
    line-height: 21px;
    position: absolute;
    right: 25px;
}

.time-box {
    width: 100%;
    height: 46px;
    position: relative;
    font-size: 12px;
    color: var(--text-color-3);
    padding-top: 10px;
}

.add-time-input {
    display: inline-block;
    margin: 0 8px;
}

.finish-input {
    position: absolute;
    left: 160px;
}

.finish-icon {
    width: 46px;
}

.add-index-readonly {
    color: var(--text-color-3);
}

/deep/ .van-dialog__header {
    font-size: 19px;
    color: var(--text-color-1);
}

.dialog-time {
    font-weight: bold;
    font-size: 50px;
    color: var(--text-color-1);
    font-family: PP;
    text-align: center;
    width: 100%;
    height: 112px;
    line-height: 112px;
}

/deep/ .van-button {
    font-size: 17px;
    height: 56px;
    line-height: 56px;
}

.start-timing {
    width: 72px;
    height: 32px;
    background: #E5F7ED;
    border-radius: 10px 10px 10px 10px;
    color: #00BD9B;
    font-size: 13px;
    line-height: 32px;
    text-align: center;
}

.start-timing-after {
    background: var(--bg-color-1);
    color: var(--text-color-3);
}

.feel-icon {
    width: 35px;
    margin-top: 20px;
}

.feel-item {
    text-align: center;
    font-size: 13px;
    line-height: 20px;
    color: var(--text-color-1);
}

.feel-not-active {
    opacity: 0.2;
}

.feel-input-box {
    width: 315px;
    margin: 0 auto 5px;
}

/deep/ .feel-input-box .van-field__control {
    background: var(--bg-color-1);
    border-radius: 8px 8px 8px 8px;
    padding: 11px 9px;
}

/deep/ .feel-input-box .van-field__control::placeholder {
    color: var(--text-color-3);
}

.circle-box {
    text-align: center;
    margin: 20px auto;
    position: relative;
    width: 270px;
    height: 270px;
}

.circle-pro {
    position: absolute;
    left: 0;
}

.circle-time {
    position: absolute;
    top: 79px
}

.circle-title {
    width: 100%;
    text-align: center;
    font-size: 19px;
    color: var(--text-color-1);
    position: absolute;
    top: 52px;
    font-family: PP;
}

.target-time {
    width: 100%;
    text-align: center;
    font-size: 19px;
    color: var(--text-color-3);
    position: absolute;
    bottom: 42px;
    font-family: PP;
}

/deep/ .van-field__control {
    color: var(--text-color-1);
}

/deep/ .van-cell {
    background-color: var(--bg-color-2);
}
</style>


// WEBPACK FOOTER //
// src/views/trainPlan/09startTrain.vue